/**
 * usePendingSkusCount — compteur badge ModuleSelector (FEAT-VALIDATION-WORKFLOW).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPendingSkusCount } from '../lib/api';

export function usePendingSkusCount() {
  return useQuery({
    queryKey: ['admin', 'pending-skus-count'],
    queryFn:  fetchPendingSkusCount,
    staleTime: 60_000,
    retry: 1,
  });
}
